var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconPrizeDraw48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PrizeDraw48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "trophy",
    transform: "translate(9.500000, 9.000000)",
    stroke: "#1E1E1E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0 L23,0 L23,13 C23,17.9705627 18.9705627,22 14,22 C9.02943725,22 5,17.9705627 5,13 L5,0 L5,0 Z",
    id: "Rectangle",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.5,5 L5.5,5 L5.5,7 C5.5,8.65685425 4.15685425,10 2.5,10 C0.843145751,10 -0.5,8.65685425 -0.5,7 L-0.5,5 L-0.5,5 Z",
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(2.500000, 7.500000) rotate(90.000000) translate(-2.500000, -7.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,5 L28.5,5 L28.5,7 C28.5,8.65685425 27.1568542,10 25.5,10 C23.8431458,10 22.5,8.65685425 22.5,7 L22.5,5 L22.5,5 Z",
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(25.500000, 7.500000) scale(-1, 1) rotate(90.000000) translate(-25.500000, -7.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 22,
    x2: 14,
    y2: 30,
    id: "Path-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 29.5,
    x2: 19.5,
    y2: 29.5,
    id: "Path-8"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconPrizeDraw48);
export default __webpack_public_path__ + "static/media/pictogramBeaconPrizeDraw48.0b134541903d941940ac70429406feae.svg";
export { ForwardRef as ReactComponent };